import { Banner, BannerDescription, BannerTitle } from '@d-edge/overnight-hotelier-react'
import { useNextScreening } from '@/api/queries'
import { dateTime } from '@/lib/format'
import styles from './DelayBanner.module.css'
import { delayLevel, formatDuration, notStartedSummary } from './nextScreening'

/** Sits in the sticky top bar while the synchronisation wave is late enough to matter, so it is never off-screen. */
export function DelayBanner() {
  const { data } = useNextScreening()
  const level = data ? delayLevel(data) : null
  if (!data || !level) return null

  const where = data.timezones.length > 0 ? ` for ${data.timezones.join(', ')}` : ''
  return (
    <Banner status={level} insideContainer className={`${styles.banner} ${level === 'critical' ? styles.critical : styles.warning}`} role={level === 'critical' ? 'alert' : 'status'}>
      <BannerTitle>RateScreener is running {formatDuration(data.delayTime)} late</BannerTitle>
      <BannerDescription>
        The {dateTime(data.scheduledAt, 'HH:mm')} wave{where} {notStartedSummary(data)}.
      </BannerDescription>
    </Banner>
  )
}
